module.exports = __webpack_public_path__ + "static/media/icon_watch.eb718511.svg";